module.exports = __webpack_public_path__ + "img/사각파라솔 (2).70a3264e.jpg";